import React, { useState, useEffect } from "react";
import FAQ from "./Faqs";
import { Link, useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import axios from "axios";


const Service = () => {
  const { tabName, subTabSlug  } = useParams();
  const navigate = useNavigate();
  const [services, setServices] = useState({});
  const [activeTab, setActiveTab] = useState(tabName || "website");
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showLogo, setShowLogo] = useState(true);
 const [faqs, setFaqs] = useState([]);
   const [showAll, setShowAll] = useState(false);
 const [showFullDescription, setShowFullDescription] = useState(false);
 const descriptionRef = React.useRef(null);
const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, ""); 
};
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get("https://dataap.werkeon.com/api/get_services.php");
        if (Array.isArray(res.data)) {
          // Group by category
          const grouped = res.data.reduce((acc, item) => {
            const cat = item.category || "website";
            if (!acc[cat]) acc[cat] = [];
            acc[cat].push({
            ...item,
            slug: slugify(item.title),
            features:
              typeof item.features === "string"
                ? item.features.split(",").map((f) => f.trim())
                : item.features,
          });
            return acc;
          }, {});
          setServices(grouped);

          const firstTab = tabName || "website";
          if (grouped[firstTab]?.length > 0) {
            setActiveSubTab(grouped[firstTab][0]);
          }
        }
      } catch (err) {
        console.error("Error fetching services:", err);
      }
    };
    fetchServices();
  }, [tabName]);
  useEffect(() => {
  if (!services[activeTab]) return;

  if (subTabSlug) {
    const found = services[activeTab].find(
      (s) => s.slug === subTabSlug
    );
    setActiveSubTab(found || services[activeTab][0]);
  } else {
    setActiveSubTab(services[activeTab][0]);
  }
}, [services, activeTab, subTabSlug]);

  useEffect(() => {
    const fetchFaqs = async () => {
      if (!activeSubTab?.id) return;

      try {
        const res = await axios.get(
          `https://dataap.werkeon.com/api/get_faqs.php?service_id=${activeSubTab.id}`
        );
        if (Array.isArray(res.data)) {
          setFaqs(res.data);
        } else {
          setFaqs([]);
        }
      } catch (err) {
        console.error("Error fetching FAQs:", err);
        setFaqs([]);
      }
    };

    fetchFaqs();
  }, [activeSubTab]);
  
  useEffect(() => {
    if (services[activeTab] && services[activeTab].length > 0) {
      setActiveSubTab(services[activeTab][0]);
    }
  }, [activeTab, services]);

  useEffect(() => {
    if (activeSubTab?.image) {
      const img = new Image();
      img.src = activeSubTab.image.startsWith("http")
        ? activeSubTab.image
        : `https://dataap.werkeon.com/api/${activeSubTab.image}`;
    }
  }, [activeSubTab]);

  useEffect(() => {
    setShowLogo(true);
    setImageLoaded(false);
    const timer = setTimeout(() => setShowLogo(false), 2000);
    return () => clearTimeout(timer);
  }, [activeSubTab]);

  const handleImageLoad = () => setImageLoaded(true);
    const imageUrl = `${process.env.PUBLIC_URL}/images/logos/header-logo.png`;
  if (!activeSubTab) {
    return <section id="portfolio" className="portfolio-section py-8 pb-0 md:py-16 px-4">
        <div className="container mx-auto text-center">
          <div className="text-center mb-4 md:mb-12">
            <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
              Our Services
            </span>
          </div>
            <div className="loading-breathing">     
    {/* <svg  className="logo-breathing" aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>             */}
                  <img
                    src="../images/logos/header-logo.png"
                    alt="Website Logo"
                    className="logo-breathing"
                  />
                </div>
        </div>
      </section>;
  }
const getShortDescription = (html, limit = 1000) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  let charCount = 0;
  let truncated = "";

  const walk = (node) => {
    if (charCount >= limit) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const remaining = limit - charCount;
      if (node.textContent.length <= remaining) {
        truncated += node.textContent;
        charCount += node.textContent.length;
      } else {
        truncated += node.textContent.substring(0, remaining) + "...";
        charCount = limit;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      truncated += `<${node.nodeName.toLowerCase()}${[...node.attributes]
        .map((a) => ` ${a.name}="${a.value}"`)
        .join("")}>`;

      node.childNodes.forEach(walk);

      truncated += `</${node.nodeName.toLowerCase()}>`;
    }
  };

  div.childNodes.forEach(walk);

  return truncated;
};


  return (
    <>
      <div className="mx-auto w-full max-w-7xl px-5 py-8 lg:py-16">
        <div className="text-center container m-auto mb-12">
          <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
            Our Services
          </span>
          <p className="text-balance mt-4 text-[12px] md:text-[16px]">
            From the moment our company was founded, we have helped our clients
            find exceptional solutions for their businesses, creating memorable
            brands and digital products. Our expertise grows with each year.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-col md:flex-row grid grid-cols-2 md:grid-cols-4 mx-auto w-full max-w-7xl items-center mb-8">
          {["website", "mobileApp", "graphic", "digital"].map((tab) => (
            <button
              key={tab}
              onClick={() => {
              setActiveTab(tab)
              navigate(`/service/${tab}`);
              }}
              className={`py-2 px-2 md:px-4 border-b-2 mt-0 md:mt-4 text-[12px] md:text-[16px] ${
                activeTab === tab
                  ? "border-blue-500 text-blue-500"
                  : "border-grey-500 text-gray-600"
              }`}
            >
              {tab === "website"
                ? "Website Development"
                : tab === "mobileApp"
                ? "Application Development"
                : tab === "graphic"
                ? "Graphic Designing"
                : "Digital Marketing"}
            </button>
          ))}
        </div>

        {/* Sub Tabs */}
        <div className="my-4 grid grid-cols-3 md:flex md:flex-wrap justify-center">
          {services[activeTab]?.map((service, index) => (
            <button
              key={index}
              onClick={() => {
                setActiveSubTab(service)
                navigate(`/service/${activeTab}/${service.slug}`);
              }}
              className={`py-2 px-2 text-[10px] md:text-[16px] md:px-6 mr-4 mb-4 rounded-md shadow-md transition-all hover:shadow-lg ${
                activeSubTab?.id === service.id
                  ? "bg-[#21AA4A] text-white shadow-lg"
                  : "bg-white text-gray-700 hover:bg-gray-200"
              }`}
            >
              {service.title}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="mt-6">
          <h3 className="text-xl font-bold">
          {activeSubTab.heading}
          </h3>

          <div className="block md:flex md:flex-wrap gap-6 mt-6 relative">
            {/* Left */}
            <div className="flex-1 relative h-full w-full md:max-w-[70%] md:pr-8 rounded-lg">
              {showLogo ? (
                <div className="loading-breathing">
                  <img
                    src={imageUrl}
                    alt="Website Logo"
                    className="logo-breathing"
                  />
                </div>
              ) : (
                <img
                  src={
                    activeSubTab.image.startsWith("http")
                      ? activeSubTab.image
                      : `https://dataap.werkeon.com/api/${activeSubTab.image}`
                  }
                  alt={activeSubTab.title}
                  className={`w-full max-h-[480px] h-full object-cover rounded-lg mb-4 ${
                    imageLoaded ? "" : "opacity-0"
                  }`}
                  onLoad={handleImageLoad}
                  loading="lazy"
                />
              )}

              {!imageLoaded && !showLogo && (
                <div className="loading-placeholder absolute top-50"><div role="status">
    <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span class="sr-only">Loading...</span>
</div></div>
              )}

              <div ref={descriptionRef} className="mt-4 mb-4 hidden md:block">
                <h2 className="text-left my-4 capitalize text-[36px] font-bold text-blue_gray-900">
                  Description
                </h2>
                <div
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(
        showFullDescription
          ? activeSubTab.description
          : getShortDescription(activeSubTab.description)
      ),
    }}
    className="text-gray-900 text-[14px] descipt"
  />
  {activeSubTab.description.length > 800 && (
    <button
  onClick={() => {
    setShowFullDescription(!showFullDescription);
    setTimeout(() => {
      descriptionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300);
  }}
      className="border border-gray-100 bg-white/80 shadow backdrop-blur-lg px-4 py-2  md:rounded-3xl font-semibold mt-2"
    >
      {showFullDescription ? "Read Less" : "Read More"}
    </button>
  )}
              </div>
            </div>

            {/* Right */}
            <div className="flex-1 w-full md:max-w-[30%] h-full bg-white border border-gray-300 p-6 rounded-lg shadow-lg md:sticky md:top-24 self-start">
              <p className="capitalize text-xl font-semibold text-center mb-2">
                Service Details
              </p>
              <div className="bg-[#e12126] h-0.5 w-full mb-4"></div>

              <ul className="w-full my-4">
                {activeSubTab.features?.map((f, i) => (
                  <li key={i}>
                    <span className="text-[#1353fe] text-[20px] font-semibold mr-2">
                      ✓
                    </span>
                    {f}
                  </li>
                ))}
              </ul>

              <span className="text-sm text-gray-500">Starting from</span>
              <div className="flex items-center justify-top text-5xl font-extrabold text-[#21AA4A]">
                <span>{activeSubTab.price}</span>
                <span className="ml-1 text-xl font-medium text-gray-500">
                  USD
                </span>
              </div>

              <Link to="/contact-us">
                <button className="mt-6 px-6 py-2 bg-[#175293] text-white w-full rounded-md shadow-lg hover:bg-blue-600">
                  Get Free Consultation
                </button>
              </Link>
            </div>

            {/* Description for mobile */}
            <div className="mt-4 mb-4 block md:hidden">
              <h2 className="text-left my-4 capitalize text-[30px] font-bold text-blue_gray-900">
                Description
              </h2>
               <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    showFullDescription
                      ? activeSubTab.description
                      : getShortDescription(activeSubTab.description)
                  ),
                }}
                className="text-gray-900 text-[12px] descipt"
              />
              {activeSubTab.description.length > 1000 && (
                <button
              onClick={() => {
                setShowFullDescription(!showFullDescription);
                setTimeout(() => {
                  descriptionRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }, 300);
              }}
                  className="border border-gray-100 bg-white/80 shadow backdrop-blur-lg px-4 py-2 rounded-2xl font-semibold mt-2"
                >
                  {showFullDescription ? "Read Less" : "Read More"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="bg-white mt-10 flex flex-col items-center justify-start px-4 py-6 shadow w-full">
        <p className="text-center text-[18px] font-semibold">
          For any queries, don’t hesitate to reach out to us. You deserve the
          best.
        </p>
        <Link
          to="/contact-us"
          className="mt-6 px-6 py-2 bg-[#175293] text-white rounded-md shadow-lg hover:bg-blue-600"
        >
          Contact us
        </Link>
      </div>

      {/* FAQs (if you have sets by title) */}
    <FAQ faqs={faqs} />
    </>
  );
};

export default Service;
